import { UserIdSchema } from "@core/domains/identity";
import { identity } from "@core/foundation/function";
import {
  createModel,
  createModelSchemas,
  noModelUpdate,
} from "@core/foundation/model";
import { createSerialId } from "@core/foundation/zod";
import { z } from "@core/zod";

import { ID_PREFIX } from "./shared/id-prefix.ts";

const { first: FIRST_EPOCH, idSchema: EpochIdSchema } = createSerialId(
  ID_PREFIX.EPOCH,
);

export { FIRST_EPOCH };

export const { first: FIRST_GRID_EPOCH, idSchema: GridEpochIdSchema } =
  createSerialId(ID_PREFIX.GRID_EPOCH);

export type EpochId = z.infer<typeof EpochIdSchema>;

export type GridEpochId = z.infer<typeof GridEpochIdSchema>;

export const Epoch = createModel({
  create: (item, schema) => {
    return { ...schema.decode(item) };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        epochId: EpochIdSchema,
        gridEpochId: GridEpochIdSchema,
        userId: UserIdSchema,
      },
      {
        epochId: "The user's current epoch, which a reset advances.",
        gridEpochId: "The user's current grid epoch.",
        userId: "The id of the user the epoch belongs to.",
      },
    ),
    derive: { create: identity, recovery: identity, update: noModelUpdate },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface Epoch extends z.infer<typeof Epoch.schema> {}
